import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
	name: 'sanitize',
	standalone: false
})
export class SanitizePipe implements PipeTransform {
	constructor (private sanitizer: DomSanitizer) {}

	public transform (value: string): string {
		return this.sanitizer.sanitize(SecurityContext.HTML, value) || '';
	}
}
